module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFlJREFUeNpiFOp+ywAEFUDczgABlUDcwcSAA1BRggWIe4HYD0ksGYhFQTpWA7ESkgSIvRokcQKIpyNJgNgnGKH+4APia1AJLSD+xALlfALibKhjQGwGgAADAMejDye7KPZNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottom.png
// module id = XCu6
// module chunks = 1